const actionType = {
    GET_INTERVIEW_QUESTIONS_CHAPTER:'GET_INTERVIEW_QUESTIONS_CHAPTER',
    GET_INTERVIEW_QUESTIONS_CHAPTER_SUCCESS:'GET_INTERVIEW_QUESTIONS_CHAPTER_SUCCESS',
    GET_INTERVIEW_QUESTIONS_CHAPTER_FAILURE:'GET_INTERVIEW_QUESTIONS_CHAPTER_FAILURE'
}
export default actionType 